import React from 'react'

import { faPencilAlt, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import styles from './table.module.scss'

interface Props {
    removeCatg: any,
    data: any,
    putUser: any
}

export const CatgTable: React.FC<Props> = ({ data, putUser, removeCatg }) => {

    function changeUserData(categoria: any) {
        putUser(categoria)
    }

    /*const [errorMessage, setErrorMessage] = React.useState(null)
    const [statusMessage, setStatusMessage] = React.useState('error-message-off error-message-table-off')*/

    return (
        <div className={styles.tableContainer}>
            <table className={styles.table}>
                <thead className={styles.thead}>
                    <tr className={styles.tr1}>
                        <th>Descrição</th>
                        <th>Caminho</th>
                        <th>Ações</th>
                    </tr>
                </thead>
                <tbody className={styles.tbody}>
                    {
                        data.map((categoria: {
                            ID: number,
                            CM_NOME: string,
                            path: string
                        }) => (
                            <tr className={styles.tr} key={categoria.ID}>
                                <td width="40%">{categoria.CM_NOME}</td>
                                <td width="55%">{categoria.path}</td>
                                <td width="5%">
                                    <div className={styles.actionContainer}>
                                        <button className={styles.pencilBox} onClick={() => changeUserData(categoria)}>
                                            <FontAwesomeIcon icon={faPencilAlt} className="" />
                                        </button>
                                        <button className={styles.trashBox} onClick={() => removeCatg(categoria)}>
                                            <FontAwesomeIcon icon={faTrashAlt} className="" />
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        )
                        )
                    }
                </tbody>
            </table>
        </div>
    )
}